export default "/_next/static/chunks/fonts/WhitneySSm-SemiboldItalic-Pro_Web-156edbb90c8ae44a65f822e7552cfecd.woff";